require('./settingsSummary.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ components
const { Toggle } = require('commonsComponents/toggle');

const SettingsSummary = props => {
    const { checked, handleClick, subTitle, title, smallTitle } = props;

    return (
        <div className="settings-summary">
            <div className="settings-summary__text">
                <div className="settings-summary__toggle">
                    <Toggle checked={checked} onClick={handleClick} />
                </div>
                <p className="settings-summary__title">
                    {title}
                    <span className="settings-summary__title--small">{smallTitle}</span>
                </p>
                <p className="settings-summary__subtitle">
                    {subTitle}
                </p>
            </div>
        </div>
    );
};

SettingsSummary.propTypes = {
    checked: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    subTitle: PropTypes.string,
    smallTitle: PropTypes.string,
    title: PropTypes.string.isRequired
};

module.exports = SettingsSummary;
